"use client";
import { filterProps } from "../../../utils/filter-props/filter-props.mjs";
//#region packages/@mantine/core/src/core/Box/style-props/extract-style-props/extract-style-props.ts
function extractStyleProps(others) {
	const { m, mx, my, mt, mb, ml, mr, me, ms, mis, mie, p, px, py, pt, pb, pl, pr, pe, ps, pis, pie, bd, bdrs, bg, c, opacity, ff, fz, fw, lts, ta, lh, fs, tt, td, w, miw, maw, h, mih, mah, bgsz, bgp, bgr, bga, pos, top, left, bottom, right, inset, display, flex, hiddenFrom, visibleFrom, lightHidden, darkHidden, sx, ...rest } = others;
	return {
		styleProps: filterProps({
			m,
			mx,
			my,
			mt,
			mb,
			ml,
			mr,
			me,
			ms,
			mis,
			mie,
			p,
			px,
			py,
			pt,
			pb,
			pl,
			pr,
			pis,
			pie,
			pe,
			ps,
			bd,
			bg,
			c,
			opacity,
			ff,
			fz,
			fw,
			lts,
			ta,
			lh,
			fs,
			tt,
			td,
			w,
			miw,
			maw,
			h,
			mih,
			mah,
			bgsz,
			bgp,
			bgr,
			bga,
			pos,
			top,
			left,
			bottom,
			right,
			inset,
			display,
			flex,
			bdrs,
			hiddenFrom,
			visibleFrom,
			lightHidden,
			darkHidden,
			sx
		}),
		rest
	};
}
//#endregion
export { extractStyleProps };

//# sourceMappingURL=extract-style-props.mjs.map